import { Timestamp } from '@klear/time'
import { buildLegalDocumentFileUrl } from '@klear/upload/file-url'

export type Klearpolicydocumenttype =
  | 'ach_agreement'
  | 'privacy_policy'
  | 'subscription_agreement'
  | 'terms_and_conditions'

export const USER_LEGAL_AGREEMENT_TITLE_MAP: Partial<Record<Klearpolicydocumenttype, string>> = {
  terms_and_conditions: 'Terms and Conditions',
  privacy_policy: 'Privacy Policy'
} as const

export const TRADER_LEGAL_AGREEMENT_TITLE_MAP: Partial<Record<Klearpolicydocumenttype, string>> = {
  subscription_agreement: 'Subscription Agreement',
  ach_agreement: 'ACH Agreement'
} as const

export type LegalAgreementJson = {
  id: number
  version: number
  name: Klearpolicydocumenttype
  url: string
  signatureRequired: boolean
  isDynamic: boolean
  esignConsentText?: string
  documentHash?: string
  createdAt?: number | Timestamp
}

export function legalAgreementToJson(agreement: LegalAgreement) {
  return {
    id: agreement.id,
    version: agreement.version,
    name: agreement.name,
    url: agreement.url,
    signatureRequired: agreement.signatureRequired,
    isDynamic: agreement.isDynamic,
    esignConsentText: agreement.esignConsentText,
    documentHash: agreement.documentHash,
    createdAt: agreement.createdAt?.epochMs
  }
}

export class LegalAgreement {
  static readonly __klearClass = 'LegalAgreement'

  id: number
  version: number
  name: Klearpolicydocumenttype
  url: string
  signatureRequired: boolean
  isDynamic: boolean
  esignConsentText?: string
  documentHash?: string
  createdAt?: Timestamp

  constructor(props: LegalAgreementJson) {
    this.id = props.id
    this.version = props.version
    this.name = props.name
    this.url = props.url
    this.signatureRequired = props.signatureRequired
    this.isDynamic = props.isDynamic
    this.esignConsentText = props.esignConsentText
    this.documentHash = props.documentHash
    this.createdAt = props.createdAt != null ? new Timestamp(props.createdAt) : undefined
    this.assertValid()
  }

  get title(): string {
    return USER_LEGAL_AGREEMENT_TITLE_MAP[this.name] || TRADER_LEGAL_AGREEMENT_TITLE_MAP[this.name] || this.name
  }

  getFileUrl(traderId: number): string {
    return buildLegalDocumentFileUrl(traderId, this.url)
  }

  assertValid(): void {
    if (!this.name) {
      throw new Error('LegalAgreement name is required')
    }
  }

  toJSON() {
    return legalAgreementToJson(this)
  }
}
